
import Vue from 'vue';
import BaseIcon from '@/components/BaseIcon.vue';

export default Vue.extend({
  name: 'ModalComponent',
  components: {
    BaseIcon,
  },
  props: {
    headline: {
      type: String,
    },
    subheadline: {
      type: String,
    },
    text: {
      type: String,
    },
    backdrop: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    image: {
      type: Object,
    },
    classes: {
      type: String,
    },
    closeLabel: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
  computed: {
    // Function for getting only sources with filled width.
    // Need to be done this way, as we can't use v-if in v-for
    imgSources() {
      let sources = [];

      // Foreach doesn't work without this condition
      if (this.$props.imgSource || !this.$props.imgSource.sources) {
        return;
      }

      this.$props.imgSource.sources.forEach(source => {
        if (source.imageSize.width) {
          sources.push(source);
        }
      });

      return sources;
    },
  },
  methods: {
    sourceMedia: function (source) {
      return `(${source.mediaQuery.condition}:${source.imageSize.width}px)`;
    },
    callback: function(e) {
      this.$emit('click', e);
    },
    mapIconColor: function() {
      let iconColorClass = '';
      switch (this.icon) {
        case 'warning':
          iconColorClass = 'text-mr-warning';
          break;
        case 'success':
          iconColorClass = 'text-mr-success';
          break;
        case 'error':
          iconColorClass = 'text-mr-danger';
          break;
      }
      return iconColorClass;
    },
    mapIconName: function() {
      let iconName = this.icon;

      if (!this.icon) {
        return null;
      }

      switch (this.icon) {
        case 'warning':
        case 'error':
          iconName = 'warning';
          break;
        case 'success':
          iconName = 'success';
          break;
      }
      return iconName;
    },
  },
});
